"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrongChoiceIcon = exports.CorrectChoiceIcon = void 0;
exports.CorrectChoiceIcon = "✅";
exports.WrongChoiceIcon = "❌";
//# sourceMappingURL=choiceIcons.js.map